import * as React from 'react';
import { Link } from '@material-ui/core'

/**
 * @description компонент AnchorTag влияет на поведение ссылок в .md файлах "[ссылка](https://ya.ru/)"
 * так, что из-за target="_blank" любая ссылка, даже относительная "[страница](/inner-page/)" - открывается в новой вкладке
 */
const AnchorTag = ({ children: link, ...props }) => {
  if (link) {
    return (
      <Link color='secondary' href={props.href} target="_blank" rel="noopener noreferrer">
        {link}
      </Link>
    );
  } else {
    return null;
  }
};

export default AnchorTag;
